// src/utils/answerChecker.ts

// @ts-ignore
import { NlpManager } from '@nlpjs/lang-en-min';

let nlpManager: NlpManager | null = null;

// Function to initialize the NLP manager
const initializeNlpManager = async (
    correctAnswers: string[],
    acceptableKeywords: string[]
): Promise<void> => {
  if (!nlpManager) {
    nlpManager = new NlpManager({ languages: ['en'] });

    const intentName = 'CORRECT_ANSWER';

    // Add acceptable answers and keywords as utterances for the intent
    correctAnswers.forEach((answer) => {
      nlpManager?.addDocument('en', answer.toLowerCase(), intentName);
    });

    acceptableKeywords.forEach((keyword) => {
      nlpManager?.addDocument('en', keyword.toLowerCase(), intentName);
    });

    // Train the NLP manager
    await nlpManager?.train();
  }
};

const answerChecker = async (
    guess: string,
    correctAnswers: string[],
    acceptableKeywords: string[]
): Promise<boolean> => {
  try {
    // Preprocess the user's guess
    const cleanGuess = guess.trim().toLowerCase();

    // First check: Keyword matching
    console.log("cleanGuess is ", cleanGuess);
    for (const keyword of acceptableKeywords) {
      const cleanKeyword = keyword.trim().toLowerCase();
      console.log("cleanKeyword is", cleanKeyword);
      if (cleanGuess.includes(cleanKeyword)) {
        console.log(" the match is true");
        return true;
      }
    }

    // Initialize the NLP manager if not already initialized
    await initializeNlpManager(correctAnswers, acceptableKeywords);

    if (!nlpManager) {
      throw new Error('NLP Manager failed to initialize.');
    }

    // Second check: Semantic similarity using NLP.js
    const response = await nlpManager.process('en', cleanGuess);

    // Check if the intent is 'CORRECT_ANSWER' with a high enough score
    const confidenceThreshold = 0.7; // Adjust based on testing
    console.log("response score is ", response.score);
    console.log("confidenceThreshold is ", confidenceThreshold);
    if (response.intent === 'CORRECT_ANSWER' && response.score >= confidenceThreshold) {
      return true;
    }

    return false;
  } catch (error) {
    console.error('Error in answerChecker:', error);
    return false;
  } finally {
    // Clean up if necessary
    // Note: keep nlpManager initialized for future calls
  }
};

export default answerChecker;
